module.exports = __webpack_public_path__ + "media/images/dmc/og-dmc-0df84db8713ed8152989715e1ba96f89.jpg";